import type {
  ActionRequiredActivityEvent,
  OperatorResponse,
  FraudAlertFormData,
  DisputeResponseFormData,
  RefundApprovalFormData,
  ChargebackResponseFormData,
  PaymentReviewFormData,
} from './types'

const RESOLUTION_LABELS: Record<string, string> = {
  false_positive:      'False positive',
  customer_confirmed:  'Customer confirmed',
  resolved_internally: 'Resolved internally',
  low_risk_on_review:  'Low risk after review',
  other:               'Other',
}

function nowDisplay(): string {
  const d = new Date()
  return (
    d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) +
    ' ' +
    d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
  )
}

export function buildOperatorResponse(
  event: ActionRequiredActivityEvent,
  data: unknown,
): OperatorResponse {
  const timestampDisplay = nowDisplay()
  let label = 'Action taken'
  let notes: string | undefined

  switch (event.type) {
    case 'fraud_alert': {
      const d = data as FraudAlertFormData
      label =
        d.action === 'resolve'
          ? `Resolved · ${RESOLUTION_LABELS[d.resolution ?? ''] ?? d.resolution}`
          : `Escalated to ${d.escalationTeam}`
      notes = d.notes || undefined
      break
    }
    case 'dispute_received': {
      const d = data as DisputeResponseFormData
      label = d.action === 'submit_evidence' ? 'Evidence submitted' : 'Dispute accepted'
      notes = d.notes || undefined
      break
    }
    case 'refund_requested': {
      const d = data as RefundApprovalFormData
      const decisionLabels: Record<string, string> = {
        approve: 'Refund approved',
        modify:  'Refund modified',
        decline: 'Refund declined',
      }
      label = decisionLabels[d.decision] ?? 'Refund reviewed'
      notes = d.notes || undefined
      break
    }
    case 'chargeback_received': {
      const d = data as ChargebackResponseFormData
      label = d.action === 'accept' ? 'Chargeback accepted' : 'Fighting chargeback'
      notes = d.notes || undefined
      break
    }
    case 'payment_under_review': {
      const d = data as PaymentReviewFormData
      label = d.decision === 'approve' ? 'Payment approved' : 'Payment declined'
      notes = d.notes || undefined
      break
    }
  }

  return { label, notes, actor: 'You', timestampDisplay }
}
